import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ColorBox from 'devextreme-react/color-box';

const useStyles = makeStyles({
  root: {
    // width: 300,
    display: 'flex',
    alignItems: 'center',
    // padding: '0px 24px',
  },
  slider: {
    marginRight: 16
  },
  gradient: {
    height: 24,
    flexGrow: 1,
    borderRadius: 4,
    marginRight: 8,
    background: `linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 0%,
      rgba(255, 154, 0, 1) 10%,
      rgba(208, 222, 33, 1) 20%,
      rgba(79, 220, 74, 1) 30%,
      rgba(63, 218, 216, 1) 40%,
      rgba(47, 201, 226, 1) 50%,
      rgba(28, 127, 238, 1) 60%,
      rgba(95, 21, 242, 1) 70%,
      rgba(186, 12, 248, 1) 80%,
      rgba(251, 7, 217, 1) 90%,
      rgba(255, 0, 0, 1) 100%
    )`
  }
});

export default function ColorEditor({ style, value, onChange, disabled }) {
  const classes = useStyles();

  const handleValueChanged = e => {
    if (e === value) return;
    onChange(e);
  }
  return (
    <div style={style} className={classes.root}>
      {/* <div className={classes.gradient}></div>
      <Typography variant='subtitle2'>{value}</Typography> */}
      <ColorBox value={value} onValueChange={handleValueChanged} disabled={disabled}/>
    </div>
  );
}